import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { sortByLabel } from "./_helpers";

export const select_schools: Query<Ctx> = async ({ sb }, _params) => {
  const { data } = await sb
    .from("schools")
    .select("id, name")
    .is("deleted_at", null);
  if (!data) return [];

  return sortByLabel(
    data.map((row: any) => ({
      label: row.name ?? "",
      value: row.id,
    }))
  );
};
